var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"md6":""}},[_c('span',[_vm._t("text")],2),_c('span',[_vm._t("value")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }